import TextField from '@mui/material/TextField';

export type AgeGroupDraft = {
  mode: 'create' | 'edit';
  id: string;
  start: number;
  end: number;
};

type AgeGroupListFormProps = {
  draft: AgeGroupDraft;
  onChange: (next: AgeGroupDraft) => void;
};

function clampAgeInput(raw: string): number {
  const n = parseInt(raw, 10);
  if (!Number.isFinite(n)) return 0;
  return Math.min(150, Math.max(0, n));
}

export default function AgeGroupListForm({ draft, onChange }: AgeGroupListFormProps) {
  return (
    <>
      {draft.mode === 'edit' && (
        <TextField
          label="ID"
          name="id"
          value={draft.id}
          disabled
          autoComplete="off"
          fullWidth
          margin="none"
        />
      )}
      <TextField
        label="Эхлэх нас"
        name="start"
        type="number"
        value={draft.start}
        onChange={(ev) => onChange({ ...draft, start: clampAgeInput(ev.target.value) })}
        inputProps={{ min: 0, max: 150, step: 1 }}
        autoComplete="off"
        fullWidth
        required
        margin="none"
      />
      <TextField
        label="Дуусах нас"
        name="end"
        type="number"
        value={draft.end}
        onChange={(ev) => onChange({ ...draft, end: clampAgeInput(ev.target.value) })}
        inputProps={{ min: 0, max: 150, step: 1 }}
        autoComplete="off"
        fullWidth
        required
        margin="none"
      />
    </>
  );
}
